import { useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';
import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiName, apiBasePath } from 'assets';
import { KitType } from '@repo/types';

export const getTaxaBarChartData = async (kitId: string, kitType: KitType) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/kits/gut_vag_composition/${kitId}/${kitType}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.MICROBIOME,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        kitId,
        kitType,
      },
    },
  );

  return response?.result || null;
};
type TaxaBarChartData = {
  [key: string]: number;
};
export const getTaxaBarChartDataQuery = (
  kitId?: string,
  kitType?: KitType,
) => ({
  queryKey: [apiName, 'taxaBarChartData', kitId],
  queryFn: () =>
    (kitId && kitType && getTaxaBarChartData(kitId, kitType)) || null,
});
const useTaxaBarChartData = (kitId: string, kitType = KitType.STOOL) => {
  const gutTypeQuery = useSuspenseQuery<TaxaBarChartData | null>(
    getTaxaBarChartDataQuery(kitId, kitType),
  );

  return gutTypeQuery;
};
export default useTaxaBarChartData;
